<template>
  <div class="row">
    <div class="col-12">
      <ul class="nav nav-tabs">
        <li class="nav-item" v-for="t in tabs" :key="t.id">
          <span class="nav-link" :class="{ 'active': currentTab === t.id }" @click="$emit('change', t.id)">
            {{ getTranslatedText(t.name) }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";

export default {
  name: 'BetslipTabs',
  mixins: [languageMixins],
  props: {
    currentTab: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tabs: [
        { id: 'SINGLE', name: 'Single' },
        { id: 'MULTIPLE', name: 'Multiple' }
      ]
    }
  }
};
</script> 